import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import { SearchAsYouTypeDataProviderService } from '../search-as-you-type/search-as-you-type-data-provider.service';
import { SearchResultModel } from '../search-as-you-type/search-result.model';
import { Contact } from '../../../vas/business-objects/contact/contact.model';

@Injectable()
export class EmailContactPickerDataProviderService extends SearchAsYouTypeDataProviderService {

    static id = 'EmailContactPicker';

    constructor(protected appFacade: VasAppFacade) {
        super();
    }

    getIdentifier(): string {
        return EmailContactPickerDataProviderService.id;
    }

    getResults(searchValue: string): Observable<Array<SearchResultModel>> {
        return this.appFacade.objects.contact.store.getBy(item => {

            if (!searchValue) {
                return true;
            }

            return this.match(item.name, searchValue) ||
                this.match(item.email, searchValue) ||
                this.match(item.address, searchValue) ||
                this.match(item.vatNumber, searchValue);
        })
            .map(contacts => {
                return contacts
                    .map(contact => this.toResult(contact))
                    .sort((a, b) => a.text.localeCompare(b.text));
            });
    }

    protected match(a: string, b: string): boolean {
        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) !== -1;
    }

    getResult(id: string): Observable<SearchResultModel> {
        return this.appFacade.objects.contact.store.get(id)
            .map(contact => this.toResult(contact));
    }

    toResult(contact: Contact): SearchResultModel {
        return {
            id: contact.id,
            text: `${contact.name} <${contact.email}>`,
            value: contact.email
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/email-contact-picker/email-contact-picker-data-provider.service.ts